import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./ArticleCommentList.modules.less";
import ScrollLoad from "@Components/common/ScrollLoad";
import CommentList from "./CommentList";
import WriteComment from "./WriteComment";
import { loginAtom } from "@Lib/jotai/login";
import { useAtom } from "jotai";

import { article } from "@Api";
import { Spin } from "antd";

const { fatchArticleGetComment } = article;

interface IState {
  commentNum: any;
  commentData: any[];
  hotComment: any[];
  paging: string;
}

const Content = () => {
  const [loginInfo, updateLoginInfo] = useAtom(loginAtom);
  const { id, type } = window.article;
  const [remarkData, setRemarkData] = useState<IState>({
    commentNum: "---",
    commentData: [],
    hotComment: [],
    paging: "",
  });
  const [showLoading, setShowLoading] = useState(false);

  const getList = async () => {
    setShowLoading(true);
    try {
      const res = await fatchArticleGetComment({ id, type });
      res && articleComment(res);
    } catch (error) {
      setShowLoading(false);
      console.log(error);
    }
  };

  const articleComment = (data: any) => {
    const hotArr: any = [],
      newArr: any = [];

    hotArr.push(data.hotComment);
    newArr.push(data.data);

    setRemarkData({
      commentData: data?.data?.length === 0 ? [] : newArr,
      commentNum: data?.comment_num,
      paging: data.paging,
      hotComment: data?.hotComment?.length === 0 ? [] : hotArr,
    });
    setShowLoading(false);
  };

  const refreshList = () => {
    setRemarkData({
      commentNum: "---",
      commentData: [],
      hotComment: [],
      paging: "",
    });
    getList();
  };

  useEffect(() => {
    getList();
    updateLoginInfo()
  }, [window.article]);

  return (
    <section className={styles["IframeComment"]}>
      <div className={styles["IframeCommentList"]}>
        <div className={styles["send-comment"]}>
          <h3 className={styles["title"]}>發佈我的評論</h3>
          {remarkData.commentData.length !== 0 && (
            <span className={styles["current-comment-count"]}>
              <a href={`/article/comments/list?type=${type}&id=${id}`} target='_blank'>
                當前<b>{remarkData.commentNum}</b>條評論{`>`}
                {`>`}
              </a>
            </span>
          )}
        </div>
        <WriteComment
          placeholder={
            remarkData.commentData.length !== 0 ? "看完文章思如泉湧，快來和小夥伴們交流想法吧~" : "快來發佈第一條評論吧"
          }
          id={id}
          type={type}
          response={() => {
            refreshList();
          }}
        />

        {showLoading && (
          <div className={styles["loading-seciton"]}>
            <Spin size='large' />
          </div>
        )}

        {remarkData.hotComment.length !== 0 && (
          <div className={styles["comment-seciton"]}>
            <CommentList commentData={remarkData.hotComment} title='熱門評論' response={() => refreshList()} />
          </div>
        )}
        {remarkData.commentData.length !== 0 && (
          <div className={styles["comment-seciton"]}>
            <CommentList commentData={remarkData.commentData} response={() => refreshList()} />
            {remarkData.commentNum > 10 && (
              <a className={styles["goComment"]} href={`/article/comments/list?type=${type}&id=${id}`} target='_blank'>
                查看全部{remarkData.commentNum}條評論 {`>`}
                {`>`}
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

const $app = document.getElementById("articles-remark");
!!$app && ReactDOM.render(<Content />, $app);
